import { useQuery } from "@tanstack/react-query";
import { pathPickQueryApi } from "@/features/pathpick/api/query";
import { PathPickKreamOptionsResponse } from "@/features/pathpick/types/response";
import { toCamelKeyObject } from "@/utils/case";

// 사이즈별 크림 시세 조회 훅 — 상세 모달이 열릴 때만 그 상품 하나를 조회한다.
// 목록 응답에 사이즈별 가격을 싣지 않는 이유: 수집을 멈춰 오래된 값이 되고,
// 목록에 채우려면 페이지의 모든 상품을 미리 불러야 해서 아무도 열지 않을 상품까지 낭비된다.
// 즉시구매가는 크림 실시간 호출, 최근 체결가는 매일 갱신되는 테이블에서 온다.
// 조회와 prefetch 가 같은 캐시를 쓰도록 키와 fetcher 를 한 곳에서 만든다.
// 둘이 조금이라도 어긋나면 미리 당겨 둔 응답이 버려지고 모달에서 다시 부른다.
export const kreamOptionsQuery = (kreamProductId: number | undefined) => ({
  queryKey: ["pathpick", "kream-options", kreamProductId],
  queryFn: async () => {
    const data = await pathPickQueryApi.getKreamOptions(
      kreamProductId as number
    );
    return toCamelKeyObject(data) as PathPickKreamOptionsResponse;
  },
  // 서버도 5분 캐시라 그보다 짧게 잡을 이유가 없다.
  staleTime: 5 * 60 * 1000,
});

const useGetKreamOptions = (
  kreamProductId: number | undefined,
  enabled: boolean
) => {
  const { data, isPending, isError } = useQuery({
    ...kreamOptionsQuery(kreamProductId),
    enabled: enabled && Boolean(kreamProductId),
  });

  return {
    kreamOptions: data?.options ?? [],
    // 크림이 막히면 200 + 빈 배열 + source="unavailable" 로 온다. 에러가 아니다.
    // 상품이 DB에 없으면 404 라서 isError 도 같은 "조회 실패"로 접는다.
    isKreamUnavailable: data?.source === "unavailable" || isError,
    isKreamOptionsPending: Boolean(kreamProductId) && enabled && isPending,
  };
};

export default useGetKreamOptions;
